export const ArticleCommentForm = {
  Form: 'form',
  NameField: 'name',
  EmailField: 'email',
  CommentField: 'comment',
  SubmitBtn: 'submit-btn',
} as const;
